// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface IsMultipleUpload {
    isMerge: boolean;
    isMultipleUpload: boolean;
    isLargeFile: boolean;
}
@Component({
    selector: 'file-size-error-modal',
    templateUrl: './file-size-error-modal.component.html',
    styleUrls: ['./file-size-error-modal.component.scss'],
})
export class FileSizeErrorModalComponent {
    private sizeAmountMessage: string;
    private bodyMessage: string;
    private titleMessage: string;
    constructor(
        private dialogRef: MatDialogRef<FileSizeErrorModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IsMultipleUpload
    ) {
        this.sizeAmountMessage = data.isLargeFile === null || data.isLargeFile === undefined ? '25' : data.isLargeFile ? '100' : '25';
        if (data.isMultipleUpload) {
            this.titleMessage = `One of the Selected Files Exceeds ${this.sizeAmountMessage} MB`;
            this.bodyMessage = `Please select files that exceed no more than ${this.sizeAmountMessage} MB`;
        } else if (data.isMerge) {
            this.titleMessage = `The Merged Document Will Exceed ${this.sizeAmountMessage} MB`;
            this.bodyMessage =
                'The document you are attempting to add will exceed the maximum allowed file size for a merged document. Please add a smaller document or create another merge document request.';
        } else {
            this.titleMessage = `The Selected File Exceeds ${this.sizeAmountMessage} MB`;
            this.bodyMessage = `Please select a file that exceeds no more than ${this.sizeAmountMessage} MB`;
        }
    }

    get getBodyMessage() {
        return this.bodyMessage;
    }

    get getTitleMessage() {
        return this.titleMessage;
    }

    @HostListener('window:keyup.Enter', ['$event'])
    onDialogClick(event: KeyboardEvent): void {
        this.close();
    }

    close() {
        this.dialogRef.close();
    }
}
